import image404 from '../../assets/images/404.svg'
import './PageNotFound.scss';

export function PageNotFound() {
  return (
    <div id='page-not-found'>
      <img alt="404" src={image404} />
      <div className="center-text">{`Sorry, the page was\nnot found`}</div>
    </div>
  )
}